import { render, staticRenderFns } from "./screen.vue?vue&type=template&id=4e5db18d&scoped=true&"
import script from "./screen.vue?vue&type=script&lang=js&"
export * from "./screen.vue?vue&type=script&lang=js&"
import style0 from "./screen.vue?vue&type=style&index=0&id=4e5db18d&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5db18d",
  null
  
)

export default component.exports